import React, { useContext, useEffect, useRef, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import useAuthService from '../../../app/services/hooks/useAuthService';
import { AuthContext } from '../../../contexts/AuthContext';
import { mapAuthResponse } from '../../../app/models/Auth';
import InputField from '../../../components/InputField';
import ButtonGeneral from '../../../components/buttons/ButtonGeneral';
import logo_monere from '../../../assets/images/logo_monere.png';
import '../Login/Login.css';

/**
 * Activa la cuenta con el enlace del correo de verificación e inicia sesión.
 * Si el enlace no sirve, permite pedir uno nuevo.
 */
const VerifyEmail: React.FC = () => {
    const history = useHistory();
    const location = useLocation();
    const { login } = useContext(AuthContext);
    const { verifyEmail, resendVerification, fetchingVerifyEmail, fetchingResendVerification } = useAuthService();
    const [error, setError] = useState<string | null>(null);
    const [email, setEmail] = useState('');
    const started = useRef(false);

    const params = new URLSearchParams(location.search);
    const token = params.get('token') || '';
    const next = params.get('next') || '';

    useEffect(() => {
        if (started.current) return;
        started.current = true;
        if (!token) {
            setError('Falta el enlace de verificación.');
            return;
        }
        verifyEmail(token, {
            onSuccess: (response) => {
                if (login) login(mapAuthResponse(response.data.auth));
                toast.success(response.message);
                history.replace(next.startsWith('/intranet') ? next : '/intranet');
            },
            onError: (response) => setError(response.message || 'El enlace no es válido.')
        });
    }, []);

    const handleResend = () => {
        resendVerification(email.trim(), {
            onSuccess: (response) => toast.success(response.message),
            onError: (response) => toast.error(response.message)
        });
    };

    return (
        <div className="login-container">
            <div className="login-background"><div className="login-background-pattern" /></div>
            <div className="container position-relative" style={{ maxWidth: 520 }}>
                <div className="card shadow">
                    <div className="card-body p-4 p-md-5 text-center">
                        <img src={logo_monere} alt="Monere" style={{ height: 56 }} className="mb-4" />
                        {!error ? (
                            <>
                                <div className="spinner-border text-primary mb-3" />
                                <p className="text-muted mb-0">{fetchingVerifyEmail ? 'Activando tu cuenta…' : 'Un momento…'}</p>
                            </>
                        ) : (
                            <>
                                <h4 className="mb-2">No pudimos activar tu cuenta</h4>
                                <p className="text-muted">{error}</p>
                                <div className="text-start mb-3">
                                    <InputField label="Tu correo" type="email" value={email} onChange={setEmail} />
                                </div>
                                <ButtonGeneral onClick={handleResend} title="Enviarme un nuevo enlace" fullWidth
                                               icon="fa-paper-plane" loading={fetchingResendVerification} />
                                <a href="/login" className="d-block mt-3 small">Ir a iniciar sesión</a>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default VerifyEmail;
